// eslint-disable-next-line jira/filename-case
import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import AkSpinner from '@atlaskit/spinner/spinner';

export default function Spinner({ testId }: { testId?: string }): React.JSX.Element {
	return (
		<UFOLoadHold name="legacy-spinner">
			<Box xcss={containerStyles.root}>
				<Box xcss={wrapperStyles.root}>
					<AkSpinner size="large" testId={testId} />
				</Box>
			</Box>
		</UFOLoadHold>
	);
}

const containerStyles = cssMap({
	root: {
		display: 'flex',
		justifyContent: 'center',
		alignContent: 'center',
		height: '100%',
	},
});

const wrapperStyles = cssMap({
	root: {
		alignSelf: 'center',
	},
});
